import routes from '@/constants/routes';
import {
  getAction,
  INIT,
} from '@/store/user/actions';

export default {
  async mounted() {
    const user = await this.$store.dispatch(getAction(INIT));

    if (!user.isAuthenticated) {
      await this.$router.push(`${routes.signup}?referrer=${encodeURIComponent(this.$route.fullPath)}`);
    }
  },
};
